/// <reference types="@angular/localize" />

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { CalAngularModule } from '@cvx/cal-angular';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeng/themes';
import Material from '@primeng/themes/material';

import { AppComponent } from './app/app.component';
import { AppConfig } from './app/app-config.service';
import { routes } from './app/app.routes';
import { WorkflowService } from './app/features/workflows/services/workflow.service';
import { ToolService } from './app/features/tooling/services/tool.service';
import { AuthInterceptor } from './app/shared/interceptors/auth-interceptor';
import { SecurePipe } from './app/shared/pipes/secure.pipe';
import { DialogHelper } from './app/shared/utilities/helpers/dialog-helper/dialog-helper';

async function main() {
  const appConfig = new AppConfig();

  await appConfig.load();

  bootstrapApplication(AppComponent, {
    providers: [
      provideRouter(routes),
      provideHttpClient(
        withInterceptorsFromDi(),
      ),
      ToolService,
      WorkflowService,
      SecurePipe,
      DialogHelper,
      importProvidersFrom(
        CalAngularModule.forRoot(`assets/config.json`),
      ),
      { provide: AppConfig, useValue: appConfig },
      { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },

      // PrimeNG Providers
      provideAnimationsAsync(),
      providePrimeNG({
        theme: {
          preset: MaterialPreset,
          options: {
            prefix: 'p',
            darkModeSelector: 'false',
            cssLayer: true,
            ripples: false
          }
        }
      })
    ]
  }).catch(err => console.error(err));
}

main();

const MaterialPreset = definePreset(Material, {
  semantic: {
    primary: {
      500: '#0B2D71',
      700: '#0B2D71'
    }
  }
});

